module.exports = __webpack_public_path__ + "ff27ca3405bc70444409f138274b9fa6.png";